module.exports = __webpack_public_path__ + "img/hero-2.3354066a.svg";